import { http } from '@/http/index'

async function getRecommendedListGirl() {
	return http.get(`/consumer/chat-recommended-girls`).then((response) => response.data.data)
}

export { getRecommendedListGirl }
